<template>
  <div>
    <!-- <img :src="'/image/' + lang + '/header.png'" alt /> -->
    <!-- <img src="@/assets/img/header.png" alt /> -->
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Pahocf from '../components/paho.js'
import { activeMqttConfig } from '../mqtt/topicConfig'
// import { WebLog } from '../api'

export default {
  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      mqttUrl: this.GLOBAL.mqttUrl,
      mqttPath: this.GLOBAL.mqttPath,
      mqttOptions: this.GLOBAL.mqttOptions,
      // websocket走11883---------mqtt走1883
      mqttPort: this.GLOBAL.mqttPort,
      clientId: 'webio4mqttexample1',
      subscription: '#', // 訂閱所有
      topic: '',
      mqttClient: '',
      screenShotImgArr: []
    }
  },
  beforeDestroy () {
    // clearInterval(this.reApi)
  },
  mounted () {
    // mqtt建立 帶入世界毫秒當唯一id 可用可不用
    this.clientId += new Date().getUTCMilliseconds()
    // eslint-disable-next-line no-undef
    this.mqttClient = new Paho.MQTT.Client(this.resolveMqttUrl(), this.clientId)
    this.mqttClient.onMessageArrived = this.MessageArrived
    this.mqttClient.onConnectionLost = this.ConnectionLost
    this.$store.commit('AddmqttClient', this.mqttClient)
    this.Connect()
  },
  computed: {
    flagAdd: {
      get () {
        return this.$store.state.flagAdd
      },
      set () {}
    },
    printingType: {
      get () {
        return this.$store.state.printingType
      },
      set () {}
    },
    deviceList: {
      get () {
        return this.$store.state.deviceList
      },
      set () {}
    }
  },
  watch: {
    flagAdd: {
      handler (newValue, oldValue) {
        console.log(newValue)
        console.log(oldValue)
        if (newValue !== oldValue) {
          this.screenShotImgArr = []
          this.$store.commit('screenShotImgArr', this.screenShotImgArr)
        }
      }
    }
  },
  methods: {
    resolveMqttUrl () {
      if (this.mqttUrl) {
        return this.mqttUrl
      }

      return this.mqttPath + ':' + this.mqttPort + '/'
    },
    Connect () {
      // console.log(mqttClient)
      this.mqttClient.connect({
        onSuccess: this.Connected,
        onFailure: this.ConnectionFailed,
        keepAliveInterval: 120,
        userName: this.mqttOptions.username,
        password: this.mqttOptions.password
      })
    },
    Connected () {
      console.log('Connected')
      //   WebLog({ type: 2, msg: 'Connected' })
      activeMqttConfig.subscriptions.forEach((topic) => {
        this.mqttClient.subscribe(topic)
      })
    },
    ConnectionFailed (res) {
      console.log(res.errorMessage)
      // WebLog({ type: 2, msg: 'Connect failed:' + res.errorMessage })
    },
    ConnectionLost (res) {
      if (res.errorCode !== 0) {
        // WebLog({ type: 2, msg: 'Connection lost:' + res.errorMessage })
        this.Connect()
      }
    },
    async MessageArrived (message) {
      // console.log('@' + message.destinationName)
      // console.log(message.payloadString)
      // 定義匹配的正則表達式
      const regexPattern = /^message\/.*\/scan$/
      const regexPattern2 = /^message\/.*\/diagnose$/
      const regexPattern3 = /^message\/.*\/properties$/
      const regexPattern4 = /^message\/.*\/heartBeat$/
      const regexPattern5 = /^message\/.*\/logFiles$/
      const regexPattern6 = /^message\/.*\/getLog$/
      const regexPattern7 = /^message\/.*\/screenShot$/
      // 使用正則表達式進行匹配
      switch (true) {
        case activeMqttConfig.enabledHandlers.scan && regexPattern.test(message.destinationName): {
          console.log('scan進入同一個case')
          console.log(message.destinationName)
          // console.log(message.payloadString)
          const sacnData = JSON.parse(message.payloadString)
          const deviceMac = message.destinationName.split('/')[1]
          console.log(deviceMac)
          const foundDevice = this.IsDeviceMacInList(deviceMac)

          if (foundDevice) {
            console.log('有')
            // 如果找到符合條件的元素，則在原陣列上新增一個 status: 1 的鍵值對
            this.$set(foundDevice, 'status', 1)
            // 將修改後的 deviceList 寫回 Vuex
          } else {
            console.log('沒有')
            const newItem = {
              device_name: sacnData.name,
              device_mac: deviceMac,
              status: 1
            }
            this.deviceList.push(newItem)
          }
          this.$store.commit('deviceList', this.deviceList)
          break
        }
        case activeMqttConfig.enabledHandlers.diagnose && regexPattern2.test(message.destinationName): {
          console.log('diagnose進入同一個case')
          console.log(message.payloadString)
          break
        }
        case activeMqttConfig.enabledHandlers.properties && regexPattern3.test(message.destinationName): {
          console.log('properties進入同一個case')
          const propertiesData = JSON.parse(message.payloadString)
          console.log(propertiesData)
          this.$store.commit('propertiesData', propertiesData)
          break
        }
        case activeMqttConfig.enabledHandlers.heartBeat && regexPattern4.test(message.destinationName): {
          // console.log('各device heartBeat')
          // console.log(message.payloadString)
          // const propertiesData = JSON.parse(message.payloadString)
          // console.log(propertiesData.swList[3])
          break
        }
        case activeMqttConfig.enabledHandlers.logFiles && regexPattern5.test(message.destinationName): {
          console.log('logFiles進入同一個case')
          console.log(message.destinationName)
          console.log(message.payloadString)
          const logFilesData = JSON.parse(message.payloadString)
          this.$store.commit('logFilesData', logFilesData)
          break
        }
        case activeMqttConfig.enabledHandlers.getLog && regexPattern6.test(message.destinationName): {
          console.log('getLog進入同一個case')
          console.log(message.destinationName)
          console.log(JSON.parse(message.payloadString))
          const newMessage = JSON.parse(message.payloadString)
          const expMime = {
            gz: 'application/gzip',
            log: 'text/plain'
          }
          const type = newMessage.file.split('.').reverse()[0]
          const blob = this.base64ToBlob(newMessage?.data, expMime[type])
          const objUrl = URL.createObjectURL(blob)
          const aLink = document.createElement('a')
          aLink.href = objUrl
          aLink.download = newMessage.file
          document.body.appendChild(aLink)
          aLink.click()
          document.body.removeChild(aLink)
          break
        }
        case activeMqttConfig.enabledHandlers.screenShot && regexPattern7.test(message.destinationName): {
          console.log('screenShot進入同一個case')
          console.log(message.destinationName)
          // console.log(message.payloadString)
          const screenShotbase64 = JSON.parse(message.payloadString)

          // 將base64數據轉為圖片URL
          const imageURL = `data:image/png;base64,${screenShotbase64.img}`
          this.screenShotImgArr.push(imageURL)
          this.$store.commit('screenShotImgArr', this.screenShotImgArr)

          break
        }

        default:
          // 預設處理邏輯
          console.log('未知的 message')
      }
    },
    base64ToBlob (base64Str, mime) {
      const byteCharacters = window.atob(base64Str)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: mime })
      return blob
    },
    IsDeviceMacInList (targetMac) {
      // 使用 Array.find 方法檢查是否有符合條件的元素
      return this.deviceList.find((device) => device.device_mac === targetMac)
    },
    PlanFailOpdNoList (payment) {
      this.failOpdNoList = JSON.parse(localStorage.getItem('failOpdNoList'))
      if (!this.failOpdNoList) this.failOpdNoList = []
      this.failOpdNoList.push({
        ReceiptNo: payment.ReceiptNo
      })
      localStorage.setItem('failOpdNoList', JSON.stringify(this.failOpdNoList))
    }
  }
}
</script>

<style lang="css" scoped>
</style>
